import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './i18n/i18n';

// Content protection: disable dev tools in production
if (process.env.NODE_ENV === 'production') {
  const devtools = /./;
  devtools.toString = function() { return ''; };
  console.log('%c', devtools);
}

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
